export default __webpack_public_path__ + "static/media/acros-trio-red.38fa6576.jpg";